<template>
  <div class="card">
    <router-link tag="a" :to="{name: 'product', params: { country: item.country, slug: item.slug }}">
        <figure class="image">
            <img class="card-image" :src="item.image" :alt="item.name">
        </figure>
    </router-link>
    <div class="card-content">
        <div class="content">
            <h5 class="title is-4">{{ item.name }}</h5>
            <p class="subtitle is-6"><strong>{{ item.country }}</strong> Category: {{ item.category }}</p>
            <!-- <p class="subtitle is-6">{{ item.description.substring(0, 50) }}</p> -->
            <p class="has-text-danger">${{ item.rrpPrice }}</p>
            <p class="has-text-success">In Stock: {{ item.hasStockSomewhere }}</p>

            <AlertMeButton :item="item" />
            <MaxPriceWidget :item="item" />
            <!-- v-if="item.maxPrice" /> -->
            
            <router-link tag="a" class="button" :to="{ name: 'product', params: { country: item.country, slug: item.slug }}">Description</router-link>
            <button class="button is-primary" @click="addToCart(item)">Buy Now</button>
        </div>
    </div>
  </div>
</template>

<script>
import mixins from '@/mixins/mixins';
// import Api from '@/config/Api'; // MCH added

import AlertMeButton from './AlertMeButton';
import MaxPriceWidget from './MaxPriceWidget';




export default {
    props: ['item'],
    components: {
        AlertMeButton,
        MaxPriceWidget
    },
    mixins: [mixins],
   
    /*MCH START*/
    /* data() {
        return {
            rrpPrice: '8',
            // pricey: '',
        }
    }, */
    /*created() {
        Api().get('/productGroups')
            .then(response => {
                // this.productGroups = response.data.productGroups;

                console.log("AA:",this.productGroup.rrpPrice); 
                //this.$set(this.productGroup, 'rrpPrice', 0);
                //console.log("BB:",this.productGroup.rrpPrice); 
            });
    }*/
    /*MCH END*/


}
</script>

<style scoped>
    .card-title {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/cards/ProductCard.vue